(ns ycweb.components.pagination
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   #?@(:cljs
       [[cljs-time.format :as format]
        [cljs-time.coerce :as coerce]])
   [ycweb.components.forms :as forms]
   [util.string :as str]
   [ycweb.components.common :as cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.grid :as grid]
   [ycweb.util.comms :as comms]
   [ycweb.components.toaster :as toaster]))

(defn current-page-data [pagination-atom data]
  (let [page-size (or @(rum/cursor pagination-atom :page-size) 20)
        page-number (or @(rum/cursor pagination-atom :page) 0)]
    (->>
      data
      (drop (* page-number page-size))
      (take page-size))))

(rum/defc pagination-control < rum/reactive
  [pagination-atom {:keys [row-count row-limit next-dispatch-fn] :as cfg}]
  (let [page-size (or (cmn/curact pagination-atom :page-size) 20)
        page (or (cmn/curact pagination-atom :page) 0)

        page-limit (u/ceil (/ row-limit page-size))
        page-count (u/ceil (/ row-count page-size))]

    (when (> page-count 1)
      [:div
       [:p {:class "form-label  u-text-center"}
        "Page " (inc page) " of " page-count]
       [:div {:class (u/bem :flex-grid-group [:fluid :valign-middle])}
        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (> page 1) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (> page 1) #(swap! pagination-atom assoc :page 0))}
           "<<"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (pos? page) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (pos? page) #(swap! pagination-atom assoc :page (dec page)))}
           "<"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class
            (u/bem :button [(if (< (inc page) page-count) :primary :disabled) :default :raised] :alertonly)
            :on-click
            (fn []
              (when (< (inc page) page-count)
                (do
                  (when (and (= (inc page) page-limit) next-dispatch-fn)
                    (next-dispatch-fn))
                  (swap! pagination-atom assoc :page (inc page)))))}
           ">"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (< (inc page) (dec page-count)) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (< (inc page) (dec page-count)) #(swap! pagination-atom assoc :page (dec page-count)))}
           ">>"]]]]])))

